import React, { useContext } from 'react';
import { MapContext } from '../../store/context';
import { Box, Spacer } from '@mui/system';


export default function MapTools({ children }) {
  const ctx = useContext(MapContext)
  
  return (
    <Box
      boxShadow={0}
      sx={{
        marginLeft: "auto",
        m: "16px",
        position: "fixed",
        top: 0,
        right: document.body.clientWidth * (ctx.inspectorWidth / 12)
      }}
    >
      {children.map((child, index) => (
        <Box key={index} sx={{ marginBottom: "8px" }} >
          {child}
        </Box>
      ))}
    </Box>
  );
}